import "./index.less";
import { BASEURL } from "../../api/api.js";
// import Verify from "../../components/Verifition/Verify.vue";
new Vue({
  el: "#app",
  //   components: {
  //     Verify,
  //   },
  data: function () {
    return {
      dialogVisible: false,
      formInline: [
        {
          brand: "",
          business: "",
          relation: "",
          medicineCreateReqList: [
            {
              name: "",
              specifCreateReqList: [
                { specification: "", shortKey: "", platformIds: [] },
              ],
            },
          ],
        },
      ],
      times: 0,
      mobile: "",
      name: "",
      code: "",
      remark: "",
      email: "",
      company: "",
      platFormList: [],
    };
  },
  methods: {
    submited() {
      if (this.name == "") {
        this.$message.error("请输入姓名！");
        return false;
      }
      if (this.mobile == "" || this.code == "") {
        this.$message.error("请输入手机号、验证码!");
        return false;
      }
      axios
        .post(BASEURL + "/admin-api/website/submit", {
          name: this.name,
          mobile: this.mobile,
          company: this.company,
          code: this.code,
          email: this.email,
          remark: this.remark,
          brandCreateReqList: this.formInline,
        })
        .then((res) => {
          if (res.data.code === 0) {
            this.$message.success("提交成功！");
          } else {
            this.$message.error(res.data.msg);
          }
          this.dialogVisible = false;
        })
        .catch((e) => this.$message.error(e.msg));
    },
    getPlatformList() {
      axios
        .get(BASEURL + "/admin-api/drug/platform/list-all-simple")
        .then((res) => {
          this.platFormList = res.data.data;
        });
    },
    addpp() {
      this.formInline.push({
        brand: "",
        business: "",
        relation: "",
        medicineCreateReqList: [
          {
            name: "",
            specifCreateReqList: [
              { specification: "", shortKey: "", platformIds: [] },
            ],
          },
        ],
      });
    },

    deletepp(index) {
      this.formInline.splice(index, 1);
    },
    addyp(index, num) {
      this.formInline[index].medicineCreateReqList.push({
        name: "",
        specifCreateReqList: [
          { specification: "", shortKey: "", platformIds: [] },
        ],
      });
    },
    deleteyp(index, num) {
      this.formInline[index].medicineCreateReqList.splice(num, 1);
    },
    addgg(index, num) {
      this.formInline[index].medicineCreateReqList[
        num
      ].specifCreateReqList.push({
        specification: "",
        shortKey: "",
        platformIds: [],
      });
    },
    deletegg(index, num, i) {
      this.formInline[index].medicineCreateReqList[
        num
      ].specifCreateReqList.splice(i, 1);
    },
    getma() {
      if (this.mobile == "") {
        this.$message.error("请输入手机号!");
        return false;
      }
      this.times = 60;
      let w = setTimeout(() => {
        this.times--;
      }, 1000);
      if (!this.times) {
        clearTimeout(w);
      }

      axios
        .post(BASEURL + "/admin-api/system/auth/send-sms-code", {
          mobile: this.mobile,
          scene: "22",
        })
        .then((response) => this.$message.success("发送成功！"));
    },
    open() {
      
      this.dialogVisible = true;

      this.getPlatformList();
    },
    handleClose() {
      this.dialogVisible = false;
    },
  },
});
$(function () {
  var tId = null; //

  // 初始化数字跳动动画的变量
  window.onScrollElement.dataHandle();

  // 图片懒加载和移动到数字处跳动动画
  window.onscroll = function () {
    //获取window.onScrollElement.dataHandle()方法存储的数字对象的集合
    var elementArry = window.onScrollElement.elementArry;
    var clientHeight = $(window).height(); //获取窗口的高度
    clearTimeout(tId);
    tId = setTimeout(function () {
      window.lazyLoad(clientHeight); //图片懒加载的方法

      // 遍历数字的集合
      elementArry.forEach((obj, i) => {
        // 调用监听数字滚动函数
        window.onScrollElement.onScrollAuto(obj, clientHeight);
      });
    }, 100);
  };

  window.lazyLoad(window.onScrollElement.clientHeight);

  // 切换页面的拓客线索、智能触达等菜单
  var Element = document.createElement("div");
  var targetElement = "home-data-logo";
  var activeElement = "home-data-active";
  var switchElement = "home-toke-clue";
  $(".home-data-logo > div:nth-child(1)").addClass(activeElement);
  $(".home-data-logo > div").mouseenter(function () {
    window.commonjs.switchToke(
      $(this), //当前点击的div
      Element, //添加的倒三角图标
      targetElement, //切换的目标类名
      activeElement, //选中目标类名
      switchElement //切换的目标类名
    );
  });

  $(".home-assistance-statistic > div").mouseenter(function () {
    $(".home-assistance-statistic > div").removeClass(
      "assistance-statistic-active"
    );
    $(this).addClass("assistance-statistic-active");
  });

  swiper2();
  function swiper2() {
    var mySwiper = new Swiper(".home-banner-swipe", {
      pagination: ".banner-pagination",
      // loop:true,
      grabCursor: true,
      paginationClickable: true,
      autoplay: 3000,
    });
  }

  $(".home-consult-input > button").click(function () {
    const reg = /^1[3456789]\d{9}$/;
    var telephone = $("#telephone").val();
    var name = $("#name").val();
    var demand = $("#demand").val();
    if (reg.test(telephone) === true) {
      if (name != "") {
        if (demand != "") {
          putInfo();
        } else {
          VtMessage.info({
            duration: 2000,
            content: "帮助内容不能为空",
            offset: "vt-top-center vt-fixed",
          });
        }
      } else {
        VtMessage.info({
          duration: 2000,
          content: "请输入联系人姓名",
          offset: "vt-top-center vt-fixed",
        });
      }
    } else {
      VtMessage.info({
        duration: 2000,
        content: "请填入有效手机号码",
        offset: "vt-top-center vt-fixed",
      });
    }
  });

  $(".home-swipe-left")
    .find("button")
    .click(function () {
      var telePhone = $(".home-swipe-left input ").val();
      if (telePhone != "") {
        $(".home-swipe-left input ").val("");
        var url = "register.html#" + telePhone;
        //    location.href = url;
        window.open(url, "_blank");
      } else {
        VtMessage.info({
          duration: 2000,
          content: "手机号码不能为空",
          offset: "vt-top-center vt-fixed",
        });
      }
    });
});



// WEBPACK FOOTER //
// ./src/view/index/index.js